import React from 'react';
import Home from '../Home';
import WordPressIllustration from '../../img/wordpressWebDesign.jpg'
import WordpressDesign from '../../img/wordpress-website-design.jpg'
import WordpressLg from '../../img/WordPress-Development-india-compressor.png'
import WordpressForAll from "../../img/WordPress-Website-Design-Service-768x395.png"

export default function WorpressDesign() {
  return (
    <Home>
    <div className="min-h-screen flex flex-col text-[#333] font-sans bg-gray-50">
      {/* Header Section */}
      <header className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-8">
            <div className="max-w-xl text-center md:text-left">
              <p className="text-gray-600 text-sm sm:text-base font-semibold mb-2">Turning Visions Into Realities</p>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-4">
                <span className="text-black">through Wordpress Web Design</span><br />
                Company in India
              </h1>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed mb-6">
                Your website is a digital identity for your business. It is a powerful tool to engage and convert your visitors into professionals. We put your vision into action and work to create a website that not only looks good but also converts your visitors.
              </p>
              
            </div>
            <div className="w-full max-w-sm md:max-w-md lg:max-w-lg aspect-square flex items-center justify-center p-4">
              <img src={WordPressIllustration} alt="Web design illustration" className="w-full h-full object-contain" />
            </div>
          </div>
        </div>
      </header>

      {/* Custom Web Design Services Section */}
      <section className="bg-gray-100 py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Wordpress Web Design Services</h2>
          </div>
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-center gap-8 lg:gap-16">
            <div className="w-full lg:w-1/3 flex-shrink-0">
              <img src={WordpressDesign} alt="Illustration 1" className="w-full object-contain rounded-lg" />
            </div>
            <div className="w-full lg:w-2/3 text-left">
              <ServiceCard
                title="Wordpress Experts"
                text="Don't have the idea of having a generic website that doesn't fit with everything else on this page? That's not the purpose of a good website. SRK Softwares specializes in custom WordPress websites, as we are a leading custom WordPress design and development company. Our professionals have years of experience and go above and beyond the code themes that everyone has programmed to produce an attractive website for your business."
              />
              <ServiceCard
                title="Website Evaluation"
                text="A good website that is not working on a professional website can't be good for business. That's why SRK Softwares offers a complete evaluation of the website before starting any work. We'll find out the areas where the customers are looking at your page content, and from there we work on getting the customer to convert into a professional. The purpose of a website is to engage with your customer."
              />
              <ServiceCard
                title="Website Hosting"
                text="Your website should have all the components for creating a flawless user experience. SRK Softwares is always about providing excellent service. Website hosting is the most important part of a business. Our web hosting services provide excellent uptime and package that is tailored to your needs. Our web hosting services provide excellent uptime and packages that are tailored to your needs. This way we ensure the security of your website is always on our minds. Get in touch with us today for a free quote on your website, and a free website evaluation."
              />
            </div>
          </div>
        </div>
      </section>

      {/* Custom WordPress Website Design Process Section */}
      <section className="bg-white py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-200 py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Custom WordPress Website Design Process</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <ProcessCard
              title="Discussion and Research"
              text="During our initial discussion, we gain insights into your goals, target audience, and business. This research helps us tailor our design and marketing to suit your needs, so that the design speaks to your target audience."
              buttonText="Get Started"
            />
            <ProcessCard
              title="Planning and Strategy"
              text="We plan out the structure, layout, and functionality of your WordPress website. This stage is crucial to ensure we build a website that is not only visually appealing but also user-friendly and effective for your business."
              buttonText="Get Started"
            />
            <ProcessCard
              title="Design and Development"
              text="Our expert designers and developers create a unique and appealing website, incorporating your brand’s identity and vision. We use our creativity and skills to make your website stand out from the crowd."
              buttonText="Get Started"
            />
            <ProcessCard
              title="Launch and Support"
              text="Once you approve the design, we launch the website. We then monitor it and provide ongoing support to make sure it runs smoothly. We are always here to help with any issues or modifications that you may need."
              buttonText="Get Started"
            />
          </div>
        </div>
      </section>

      {/* Why My Business Needs Section */}
      <section className="bg-gray-100 py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Why your Business Needs A Custom Website Designer </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <WhyNeedsCard
              title="Distinct Brand Identity"
              text="We create a unique website that reflects your brand’s personality. The website design will be recognizable on the internet and will help you create a lasting impression with your customers."
            />
            <WhyNeedsCard
              title="Tailored User Experience"
              text="We tailor the website design to meet the specific needs of your audience. The website will be intuitive and easy to use, providing a seamless experience for your customers."
            />
            <WhyNeedsCard
              title="Optimized for Performance"
              text="We build websites that load quickly and are optimized for all devices. This is important as a slow-loading website can result in a loss of customers and negatively affect your search engine ranking."
            />
            <WhyNeedsCard
              title="Responsive and Mobile-Friendly"
              text="A good website looks great on all devices, whether it’s a desktop, tablet, or smartphone. Our designs are fully responsive and mobile-friendly."
            />
            <WhyNeedsCard
              title="Search Engine Friendliness"
              text="A website that is easy to find on search engines can help you increase your audience and customers. Our designs are optimized for search engines so that your customers can find you easily."
            />
            <WhyNeedsCard
              title="Scalability and Future-Proofing"
              text="We build websites with future growth in mind. The website is scalable and can easily adapt to new features and technologies. It's a website that will grow with your business."
            />
          </div>
        </div>
      </section>

      
    </div>

    <div className="min-h-screen flex flex-col text-[#333] font-sans bg-gray-50">


      {/* Why Custom Web Design and Development is the Best Option Section */}
      <section className="bg-gray-800 text-white py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white text-[#333] py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Why Custom Web Design and Development is the Best Option?</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <OptionCard
              number="1"
              title="Kissmetrics"
              text="A two-second delay in page load time causes 40% of internet consumers to get a website."
            />
            <OptionCard
              number="2"
              title="UX"
              text="It is said that 95 percent of online customers quit a business that offers a bad user experience."
            />
            <OptionCard
              number="3"
              title="Ironpaper"
              text="Around 89 percent of internet visitors believe that website design is the most important aspect of a company’s credibility."
            />
            <OptionCard
              number="4"
              title="ResearchGate"
              text="The quality of your website and the content of a website account for 94% of first impressions."
            />
          </div>
        </div>
      </section>

      {/* Responsive Custom Design Website Section */}
      <section className="bg-gray-100 py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Responsive Custom Design Website</h2>
          </div>
          <p className="max-w-4xl mx-auto leading-relaxed text-gray-700 mb-8">
            In today's digital landscape, your website is often the first interaction potential customers have with your brand. At SRK Softwares, we specialize in creating custom website designs that not only look visually appealing on every device but also provide an exceptional user experience.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8">
            <img src={WordpressForAll} alt="Desktop design" className="w-full max-w-[200px]" />
            <img src={WordpressForAll} alt="Tablet design" className="w-full max-w-[150px]" />
            <img src={WordpressForAll} alt="Mobile design" className="w-full max-w-[100px]" />
          </div>
          <p className="bg-red-600 text-white font-bold py-3 px-6 rounded-md uppercase">
            Enhance the user experience with responsive and load-focused website designs.
          </p>
          <button className="bg-gray-900 text-white font-bold py-3 px-6 rounded-md uppercase mt-4 hover:bg-gray-700 transition-colors duration-300">
            I am Going to Own It!
          </button>
        </div>
      </section>
      
      {/* Add On Services Section */}
      <section className="bg-white py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-200 py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">Add On Services</h2>
          </div>
          <p className="max-w-4xl mx-auto leading-relaxed text-gray-700 mb-8">
            SRK Softwares provides additional services to help your business grow. We offer a variety of services to help you reach your goals.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <AddOnCard
              icon="💬"
              title="Live Chat"
              text="Live Chat is a great way to communicate with your customers in real-time. It's a powerful tool to increase your sales and provide excellent customer service."
            />
            <AddOnCard
              icon="📆"
              title="CRM Integration & Automation"
              text="We integrate your website with your CRM to automate your sales and marketing efforts. This helps you track leads and improve your sales process."
            />
            <AddOnCard
              icon="🔔"
              title="Push Notification"
              text="Push notifications are a great way to engage your audience and keep them updated on your latest products and services. It's a powerful tool to increase your sales and conversions."
            />
            <AddOnCard
              icon="🔒"
              title="GDPR"
              text="We ensure your website is GDPR compliant, which is important for protecting your customers' data and building trust. Our experts will make sure your website is secure and compliant."
            />
            <AddOnCard
              icon="📅"
              title="3 Months Maintenance"
              text="We provide three months of free maintenance services to ensure your website runs smoothly. We'll monitor your website and provide support for any issues that may arise."
            />
          </div>
          <button className="bg-gray-900 text-white font-bold py-3 px-6 rounded-md uppercase mt-8 hover:bg-gray-700 transition-colors duration-300">
            Get Me Started!
          </button>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="bg-gray-100 py-16 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white py-4 px-6 rounded-lg shadow-md mb-8">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#333]">FAQ</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
            <FAQItem question="What is a responsive custom design website?" answer="A responsive custom design website is a website that automatically adjusts to the screen size of the device it's being viewed on. This provides an optimal viewing experience for all users." />
            <FAQItem question="Why is responsive design so important for my website?" answer="Responsive design is crucial for providing a seamless user experience on all devices, which can lead to a higher conversion rate, better search engine rankings, and increased customer satisfaction." />
            <FAQItem question="Can I use my existing website and make it responsive?" answer="Yes, we can evaluate your existing website and provide a solution to make it responsive. Our experts can help you upgrade your website to provide a better user experience." />
            <FAQItem question="Will I have to pay a one-time fee or monthly?" answer="Our pricing is based on the scope of the project. We offer custom packages to fit your specific needs and budget. We'll provide a clear quote before starting any work." />
            <FAQItem question="What is the cost of developing a responsive custom design website?" answer="The cost of a responsive custom design website depends on the complexity of the project, the features you need, and the timeline. We offer a free quote to help you get started." />
            <FAQItem question="Why is a good website necessary for a business?" answer="A good website is essential for a business as it helps you establish a strong online presence, build credibility, attract new customers, and grow your business. It's a powerful marketing tool that works 24/7." />
          </div>
        </div>
      </section>

      {/* Footer Section */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm">Stay connected with us on Facebook and LinkedIn for the latest updates, insights, and industry news.</p>
          <div className="flex justify-center items-center mt-4 space-x-4">
            <button className="bg-white text-gray-800 font-bold py-2 px-4 rounded-md uppercase text-xs">Facebook</button>
            <button className="bg-white text-gray-800 font-bold py-2 px-4 rounded-md uppercase text-xs">LinkedIn</button>
          </div>
          
        </div>
      </footer>
    </div>

    </Home>
  );
}

// Reusable Service Card Component
const ServiceCard = ({ title, text }) => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-8 text-center">
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);

// Reusable Process Card Component
const ProcessCard = ({ title, text, buttonText }) => (
  <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center">
    <img src={WordpressLg} alt="process icon" className="mb-4" />
    <h3 className="text-lg font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600 mb-4">{text}</p>
    <button className="bg-gray-900 text-white font-bold py-2 px-4 rounded-md uppercase text-xs hover:bg-gray-700 transition-colors duration-300">
      {buttonText}
    </button>
  </div>
);

// Reusable "Why Needs" Card Component
const WhyNeedsCard = ({ title, text }) => (
  <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center transition-transform duration-200 hover:translate-y-[-5px] hover:shadow-lg">
    <h3 className="text-lg font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);

// Reusable "Why Best Option" Card Component
const OptionCard = ({ number, title, text }) => (
  <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center text-center">
    <div className="w-12 h-12 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold text-lg mb-4">{number}</div>
    <h3 className="text-xl font-bold mb-2 text-[#333]">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);

// Reusable "Add On Services" Card Component
const AddOnCard = ({ icon, title, text }) => (
  <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center text-center">
    <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center text-3xl mb-4">{icon}</div>
    <h3 className="text-lg font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);

// Reusable FAQ Item Component
const FAQItem = ({ question, answer }) => (
  <div className="bg-white rounded-lg shadow-md p-6">
    <h3 className="text-lg font-bold mb-2 cursor-pointer flex justify-between items-center">{question} <span className="text-2xl text-gray-500">+</span></h3>
    <p className="text-sm leading-relaxed text-gray-600">{answer}</p>
  </div>
);


/* const ServiceCard = ({ title, text }) => (
  <div className="bg-white rounded-lg shadow-md p-6 mb-8 text-center">
    <h3 className="text-xl font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
);
 */
// Reusable Process Card Component
/* const ProcessCard = ({ title, text, buttonText }) => (
  <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center">
    <img src="https://placehold.co/100x100/ccc/666?text=Icon" alt="process icon" className="mb-4" />
    <h3 className="text-lg font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600 mb-4">{text}</p>
    <button className="bg-gray-900 text-white font-bold py-2 px-4 rounded-md uppercase text-xs hover:bg-gray-700 transition-colors duration-300">
      {buttonText}
    </button>
  </div>
); */

// Reusable "Why Needs" Card Component
/* const WhyNeedsCard = ({ title, text }) => (
  <div className="bg-white rounded-lg shadow-md p-6 flex flex-col items-center text-center transition-transform duration-200 hover:translate-y-[-5px] hover:shadow-lg">
    <h3 className="text-lg font-bold mb-2">{title}</h3>
    <p className="text-sm leading-relaxed text-gray-600">{text}</p>
  </div>
); */
